<template>
  <button
    @click="toggle"
    :title="autoplayEnabled ? 'Autoplay audio is on — tap to turn off' : 'Autoplay audio is off — tap to turn on'"
    :aria-label="autoplayEnabled ? 'Turn autoplay audio off' : 'Turn autoplay audio on'"
    :aria-pressed="autoplayEnabled"
    class="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors"
    :class="autoplayEnabled
      ? 'border-emerald-200 text-emerald-700 hover:bg-emerald-50 dark:border-emerald-800 dark:text-emerald-400 dark:hover:bg-gray-700'
      : 'border-gray-200 text-gray-500 hover:bg-gray-100 dark:border-gray-600 dark:text-gray-400 dark:hover:bg-gray-700'"
  >
    <!-- Speaker; a slash overlays it when autoplay is off -->
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5 shrink-0">
      <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor" stroke="none" />
      <template v-if="autoplayEnabled">
        <path d="M15.5 8.5a5 5 0 0 1 0 7" />
        <path d="M18.5 5.5a9 9 0 0 1 0 13" />
      </template>
      <line v-else x1="16" y1="8.5" x2="22" y2="15.5" />
    </svg>
    <span>Autoplay {{ autoplayEnabled ? 'On' : 'Off' }}</span>
  </button>
</template>

<script setup>
import { autoplayEnabled } from '../../utils/autoplayPref'

function toggle() {
  autoplayEnabled.value = !autoplayEnabled.value
}
</script>
